import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import IndexPage from '../components/IndexPage';


const IndexTemplate = ({ data }) => (
    <Layout page="home" bgColor="inherit" >
      <section>
        <IndexPage heroPic={data.file.childImageSharp.fluid} />
      </section>
    </Layout>
);

export const query = graphql`
  query {
    file(relativePath: { eq: "colonia-flower-door.jpg" }) {
      childImageSharp {
        fluid( maxWidth: 800 ) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default IndexTemplate;